export default __webpack_public_path__ + "static/media/Formaggio.9d635609.jpg";